import React, { useEffect, useState } from "react";
import { NotificationHeading } from "../../utils/helperData";
import { useDispatch, useSelector } from "react-redux";
import { GetNotification } from "../../../redux/action/Notification/NotificationAction";
import Pagination from "../../customComponent/Pagination";

const Notification = () => {
  const dispatch = useDispatch();

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const rowsPerPageOptions = [10, 20, 50, 100, "All"];
  const [currentPage, setCurrentPage] = useState(1);
  const { notificationDetails, count } = useSelector(
    (state) => state.notification
  );
  console.log("notificationDetails ", notificationDetails);

  useEffect(() => {
    dispatch(GetNotification(currentPage, rowsPerPage));
  }, [dispatch, currentPage, rowsPerPage]);
  const totalPages = rowsPerPage === "All" ? 1 : Math.ceil(count / rowsPerPage);

  const handleRowsPerPageChange = (event) => {
    const value = event.target.value;
    if (value === "All") {
      setRowsPerPage(count);
      setCurrentPage(1);
    } else {
      setRowsPerPage(Number(value));
      setCurrentPage(1);
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-3xl font-bold mb-6">Notification</h2>
      <div className="bg-white rounded-2xl shadow-sm p-4 sm:p-6">
        <div className="overflow-x-auto lg:max-h-full max-h-96">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="sticky top-0 bg-[#F1F4F9]">
              <tr>
                {NotificationHeading.map((head) => (
                  <th
                    key={head.name}
                    scope="col"
                    className="px-6 py-3 text-left text-base font-medium text-[#202224] uppercase tracking-wider"
                  >
                    {head.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {notificationDetails?.result?.data?.map((notification, i) => (
                <tr key={notification?._id}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {/* {i + 1} */}
                    {(currentPage - 1) * rowsPerPage + i + 1}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {notification.message}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {/* {new Date(notification.createdAt).toLocaleDateString()} */}
                    {notification.createdAt
                      ? new Date(notification.createdAt).toLocaleDateString(
                          "en-US",
                          { month: "2-digit", day: "2-digit", year: "numeric" }
                        )
                      : "-"}
                    {" , "}
                    {new Date(notification.createdAt).toLocaleTimeString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="flex items-center justify-end mb-4 space-x-3">
        <div className="flex items-center mt-6 ">
          <label htmlFor="rows-per-page" className="mr-2">
            Rows per page:
          </label>
          <select
            id="rows-per-page"
            value={rowsPerPage}
            onChange={handleRowsPerPageChange}
            className="border border-solid border-2 h-[34px] rounded p-1 text-gray-500"
          >
            {rowsPerPageOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>

        {totalPages > 1 && rowsPerPage !== "All" && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        )}
      </div>
    </div>
  );
};
export default Notification;
